/* global axios */
// NOOVI: Análise Comercial — feature nativa NooviChat (fase-31)
import ApiClient from './ApiClient';

class CommercialAnalysisAPI extends ApiClient {
  constructor() {
    super('commercial-analyses', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  // POST → 202 + { data: { id, status } } (ou cache_hit com o relatório completo)
  generate(data = {}) {
    return axios.post(this.url, data);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  status(id) {
    return axios.get(`${this.url}/${id}/status`);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // Baixa o PDF como blob via Axios — preserva os headers de auth
  // (access-token/client/uid). window.open só mandaria cookie e dava 401 em
  // sessão header-only (auditoria 2026-06-12).
  exportPdf(id) {
    return axios.get(`${this.url}/${id}/export.pdf`, { responseType: 'blob' });
  }
}

export default new CommercialAnalysisAPI();
